import { render, staticRenderFns } from "./FatalError.vue?vue&type=template&id=7568dece&scoped=true&"
var script = {}
import style0 from "./FatalError.vue?vue&type=style&index=0&id=7568dece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568dece",
  null
  
)

export default component.exports